<script lang="ts">
	import {callCheckToken, clearAuthToken, hasAuthToken, setAuthToken, callSignIn} from "../api";
	import {localeStr, PAGE_IS_ABOUT_TO_CHANGE_EVENT, currentPageLang, waitLocalesLoaded} from "../render";
	import {onMount} from "svelte";
	
	let signedIn = hasAuthToken();
	let showSignInDialog = false;
	let errorMessage = undefined;
	let loading = false;
	let login = "";
	let password = "";
	let localesLoaded = false;
	let lang = currentPageLang();
	
	onMount(() => waitLocalesLoaded(() => {
		localesLoaded = true;
		document.addEventListener(PAGE_IS_ABOUT_TO_CHANGE_EVENT, evt => {
			if (evt.detail.lang !== lang) {
				lang = evt.detail.lang;
			}
		});
	}));
	
	function showSignIn() {
		login = "";
		password = "";
		errorMessage = undefined;
		loading = false;
		showSignInDialog = true;
	}
	
	function loadAdminScripts() {
		const script = document.createElement("script");
		script.src = document.getElementById("admin-script-js").value;
		document.body.appendChild(script);
		window.ADMIN_SCRIPTS_LOADED = true;
	}
	
	function signIn() {
		if (loading) {
			return;
		}
		errorMessage = undefined;
		loading = true;
		callSignIn(login, password).then(result => {
			loading = false;
			if (typeof result === "object") {
				showSignInDialog = false;
				setAuthToken(result.token);
				console.log("Authenticated", result.userInfo);
				window.THIS_USER_INFO = result.userInfo;
				signedIn = true;
				loadAdminScripts();
			} else if (result === "invalid") {
				errorMessage = localeStr("invalidLoginOrPassword");
			} else {
				errorMessage = localeStr("unknownError");
			}
		});
	}
	
	if (signedIn) {
		callCheckToken().then(result => {
			if (typeof result === "object") {
				console.log("Authenticated", result);
				window.THIS_USER_INFO = result;
				loadAdminScripts();
			} else if (result === "invalid") {
				clearAuthToken();
				signedIn = false;
			}
		});
	}
</script>

{#key lang}
	{#if !signedIn && localesLoaded}
		<!-- svelte-ignore a11y-invalid-attribute -->
		<a href="#" on:click|preventDefault={showSignIn}>{localeStr("signIn")}</a>
		{#if showSignInDialog}
			<div class="modal-container">
				<div class="modal">
					<h2>{localeStr("signIn")}</h2>
					<form on:submit|preventDefault={signIn}>
						{#if errorMessage !== undefined}
							<div class="error-message">
								{errorMessage}
							</div>
						{/if}
						<div>
							<label for="sign-in-login">{localeStr("login")}</label>
							<input type="text" name="login" id="sign-in-login" bind:value={login}>
						</div>
						<div>
							<label for="sign-in-password">{localeStr("password")}</label>
							<input type="password" name="password" id="sign-in-password" bind:value={password}>
						</div>
						<div class="buttons">
							<button type="submit" disabled={loading}>{localeStr("submit")}</button>
							<button type="reset" on:click={() => showSignInDialog = false}>{localeStr("close")}</button>
						</div>
					</form>
				</div>
			</div>
		{/if}
	{/if}
{/key}
